<div class="code-editor-surface" [class.code-editor-surface--invalid]="invalid()" [style.height.px]="editorHeight()">
  <ngx-monaco-editor class="code-editor-monaco" [options]="options()" [formControl]="control" (onInit)="onEditorInit($event)"></ngx-monaco-editor>
  @if (loading()) {
    <div class="code-editor-loading" role="status" [attr.aria-label]="'shared.code-editor.loading' | translate">
      <mat-spinner diameter="22"></mat-spinner>
    </div>
  }
</div>
